import type { ErrorLog } from "../../types";
import ErrorItem from "./ErrorItem";

interface Props {
  errors: ErrorLog[];
}

export default function ErrorFeed({ errors }: Props) {
  return (
    <div className="flex flex-col gap-2 flex-1 overflow-y-auto">
      {errors.map((e) => (
        <ErrorItem key={e.id} error={e} />
      ))}
    </div>
  );
}
